import { withInstall } from '@zoryn/utils'
import Rules from './src/rules.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZRules: SFCWithInstall<typeof Rules> = withInstall(Rules)

export default ZRules
export * from './src/rules'
export * from './src/rules-component'
export * from './src/rule-aviator'
export * from './src/rule-match'
